// To learn more how this works go to https://medium.com/javascript-in-plain-english/google-analytics-with-react-router-and-hooks-16d403ddc528

import { isPlatform } from '@ionic/react'
import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import AnalyticsService from '../../services/AnalyticsService'

export const useAnalyticsLogging = () => {
  const { listen } = useHistory()

  useEffect(() => {
    const stopListening = listen((location) => {    
      if (isPlatform('hybrid')) {
        AnalyticsService.hybridPageLog(location.pathname);
      } else {
        AnalyticsService.webPageLog(location.pathname);
      }
    })

    return stopListening
  }, [listen])
}